import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import { Button } from "@/components/ui/button";

import timeOutError from "@/assets/images/pictograma-ampulheta-off.png";

export default function TimeOutError() {
  const { t } = useTranslation();
  const history = useHistory();

  const goToMenu = () => {
    history.push("/site-credentials");
  };

  return (
    <div className="flex flex-col gap-12 pb-2">
      <Header
        title={t("timeout_error.header_title")}
        subtitle={t("timeout_error.subtitle")}
      />
      <div className="flex justify-center items-center">
        <img src={timeOutError} alt="Callcenter image" />
      </div>
      <div className="flex justify-center">
        <Button
          type="button"
          variant="secondary"
          onClick={async () => {
            goToMenu();
          }}
        >
          {t("common.back")}
        </Button>
      </div>
      <div
        role="note"
        aria-label={t("accessibility.signin.icons")}
        className="flex flex-col">
        <Footer />
      </div>
    </div>
  );
}
